import { Button } from '@stape-io/promo-shared-content';
import clsx from 'clsx';
import React from 'react';

import { SearchCategory } from '@/lib/models/Search';
import styles from '@/shared/SearchDropdown/components/SearchDropdownHeader.module.scss';
import { useClientTranslation } from '@/lib/i18n/client';

interface SearchDropdownHeaderProps {
  activeTab: SearchCategory;
  setActiveTab: (tab: SearchCategory) => void;
  categories: { key: string; count: number }[] | null;
}

export function SearchDropdownHeader({ activeTab, setActiveTab, categories }: SearchDropdownHeaderProps) {
  const { t } = useClientTranslation('search');
  return (
    <div className={styles.searchHeader}>
      <div className={styles.tabs}>
        {categories?.map(({ key, count }) => (
          <Button
            key={key}
            className={clsx(styles.tabItem, 'text text-sm', activeTab === key && [styles.active, 'text-bold'])}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab(key as SearchCategory);
            }}
          >
            <span className="tabTitle" data-text={`${key} (${count})`}>
              <span> {`${t(key)} (${count})`}</span>
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
}
